"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
require("rxjs/add/observable/fromPromise");
require("rxjs/add/observable/zip");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var DatasetContainer = /** @class */ (function () {
    function DatasetContainer(pathService, languageService) {
        this.pathService = pathService;
        this.languageService = languageService;
    }
    /**
     * Get grouped paths and ungrouped paths grouped in default group.
     * @returns {Observable<Map<PathGroupDto, Array<PathDto>>>} Observable of map path group to paths list
     */
    DatasetContainer.prototype.getGroupedPaths = function (dataSetId) {
        var _this = this;
        var groupedPathItems = new Map();
        var getPaths = Observable_1.Observable.fromPromise(this.pathService.getPaths(dataSetId));
        var getPathGroups = Observable_1.Observable.fromPromise(this.pathService.getPathGroups(dataSetId));
        var getUnGroupedPaths = Observable_1.Observable.fromPromise(this.pathService.getUnGroupedPaths(dataSetId));
        var getLanguages = this.languageService.getAvailableLanguages();
        return Observable_1.Observable.zip(getPaths, getPathGroups, getUnGroupedPaths, getLanguages, function (paths, pathGroups, unGroupedPathsMap, languages) {
            pathGroups.forEach(function (pathGroup) {
                var groupPaths = pathGroup.paths.map(function (orderedPath) {
                    var pathId = orderedPath.pathId;
                    if (paths.categoryPaths.has(pathId)) {
                        return paths.categoryPaths.get(pathId);
                    }
                    else if (paths.measurePaths.has(pathId)) {
                        return paths.measurePaths.get(pathId);
                    }
                    else {
                        throw new Error("Unknown path with id: " + pathId);
                    }
                });
                groupedPathItems.set(pathGroup.name, groupPaths
                    .filter(function (path) { return path.appearanceType === idm_dataset_service_client_js_1.AppearanceType.EVERYWHERE || path.appearanceType === idm_dataset_service_client_js_1.AppearanceType.DATA; }));
            });
            var unGroupedPaths = Array.from(unGroupedPathsMap.values()).map(function (pathDto) {
                var pathId = pathDto.id;
                if (paths.categoryPaths.has(pathId)) {
                    return paths.categoryPaths.get(pathId);
                }
                else if (paths.measurePaths.has(pathId)) {
                    return paths.measurePaths.get(pathId);
                }
                else {
                    throw new Error("Unknown path with id: " + pathId);
                }
            }).filter(function (path) { return path.appearanceType === idm_dataset_service_client_js_1.AppearanceType.EVERYWHERE || path.appearanceType === idm_dataset_service_client_js_1.AppearanceType.DATA; });
            groupedPathItems.set(_this.createDefaultGroupName(languages), unGroupedPaths);
            return groupedPathItems;
        });
    };
    /**
     * Get grouped category paths and ungrouped category paths grouped in default group.
     * @returns {Observable<Map<PathGroupDto, Array<PathDto>>>} Observable of map path group to category paths list
     */
    DatasetContainer.prototype.getGroupedCategoryPaths = function (dataSetId) {
        var _this = this;
        var groupedPathItems = new Map();
        var getPaths = Observable_1.Observable.fromPromise(this.pathService.getPaths(dataSetId));
        var getPathGroups = Observable_1.Observable.fromPromise(this.pathService.getPathGroups(dataSetId));
        var getUnGroupedPaths = Observable_1.Observable.fromPromise(this.pathService.getUnGroupedPaths(dataSetId));
        var getLanguages = this.languageService.getAvailableLanguages();
        return Observable_1.Observable.zip(getPaths, getPathGroups, getUnGroupedPaths, getLanguages, function (paths, pathGroups, unGroupedPathsMap, languages) {
            pathGroups.forEach(function (pathGroup) {
                var groupCategoryPaths = pathGroup.paths
                    .filter(function (orderedPath) {
                    return paths.categoryPaths.has(orderedPath.pathId);
                })
                    .map(function (orderedPath) {
                    return paths.categoryPaths.get(orderedPath.pathId);
                });
                groupedPathItems.set(pathGroup.name, groupCategoryPaths
                    .filter(function (path) { return path.appearanceType === idm_dataset_service_client_js_1.AppearanceType.EVERYWHERE || path.appearanceType === idm_dataset_service_client_js_1.AppearanceType.DATA; }));
            });
            var unGroupedCategoryPaths = Array.from(unGroupedPathsMap.values())
                .filter(function (pathDto) {
                return paths.categoryPaths.has(pathDto.id);
            })
                .filter(function (path) {
                return path.appearanceType === idm_dataset_service_client_js_1.AppearanceType.EVERYWHERE || path.appearanceType === idm_dataset_service_client_js_1.AppearanceType.DATA;
            })
                .map(function (pathDto) {
                return paths.categoryPaths.get(pathDto.id);
            });
            groupedPathItems.set(_this.createDefaultGroupName(languages), unGroupedCategoryPaths);
            return groupedPathItems;
        });
    };
    DatasetContainer.prototype.getAllPaths = function (dataSetId) {
        return Observable_1.Observable.fromPromise(this.pathService.getPaths(dataSetId)).map(function (paths) {
            return Array.from(paths.measurePaths.values()).reduce(function (map, path) { return map.set(path.id, path); }, Array.from(paths.categoryPaths.values()).reduce(function (map, path) { return map.set(path.id, path); }, new Map()));
        });
    };
    /**
     * Create default path group name for ungrouped paths.
     */
    DatasetContainer.prototype.createDefaultGroupName = function (languages) {
        var defaultGroupName = new Map();
        languages.forEach(function (language) {
            defaultGroupName.set(language.getId(), 'Default group');
        });
        return defaultGroupName;
    };
    DatasetContainer = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_dataset_service_client_js_1.PathService, idm_message_language_service_client_js_1.LanguageService])
    ], DatasetContainer);
    return DatasetContainer;
}());
exports.DatasetContainer = DatasetContainer;
//# sourceMappingURL=dataset-container.js.map